import Path from '@leverege/path'
import ObjUtil from '@leverege/object-util'

import { Util } from '@leverege/api-attributes'
import { Object } from 'core-js';
/*
  tree : { type : "group" | "node", path : "", items : [ ...nodes... ]}
  used : { path : node, path: node }
*/

const ROOT = 'root';
const GROUP = 'group';
const ATTRIBUTE = 'attribute';

// Is the node a root node?
function isRoot( node ) {
  return node && node.type == ROOT;
}
// Is the node a root or group node?
function isGroup( node ) {
  return node && ( node.type == ROOT || node.type == GROUP );
}

function isAttribute( node ) {
  return node && node.type == ATTRIBUTE;
}

let nextId = 0;

// create a New Id
function newId() {
  return `anode-${nextId++}`;
}

// find the child of parent with the specified name
function findChildByName( parent, name ) {

  if ( isGroup( parent ) ) {
    const arr = parent.items;
    for ( let n = 0; n < arr.length; n++ ) {
      if ( arr[n].name == name ) {
        return arr[n]
      }
    }
  }
  return null;
}

// Creates or Finds the Group node that will be the parent of the given
// pathSegment
function getParentNode( root, pathArr, allowCreate ) {
  allowCreate = allowCreate === undefined ? true : allowCreate;
  if ( pathArr.length == 0 ) {
    return root;
  }

  let parent = root;
  let path = '';

  for ( let n = 0; n < pathArr.length - 1; n++ ) {
    let child = findChildByName( parent, pathArr[n] );
    path = n == 0 ? pathArr[n] : `${path}/${pathArr[n]}`;
    if ( child == null || !isGroup( child ) ) {
      child = { type : GROUP, 
                id : `tree-${path}`, 
                path, 
                name : pathArr[n], 
                items : [] };
      parent.items.push( child );
    }
    parent = child;
  }
  return parent;
}

function findNodeByPath( root, path ) {
  if ( path == null ) {
    return root;
  }
  return findNode( root, ( n ) => { return Path( n.path ).path() == Path( path ).path() } );
}

function findNodeById( node, id ) {
  if ( id == null ) {
    return null;
  }
  return findNode( node, ( n ) => { return n.id == id } );
}

function findNode( node, condition ) {
  if ( node == null ) {
    return null;
  }
  if ( condition( node ) ) {
    return node;
  }
  if ( isGroup( node ) ) {
    for ( let n = 0; n < node.items.length; n++ ) {
      const fn = findNode( node.items[n], condition );
      if ( fn ) {
        return fn;
      }
    }
  }
  return null;
}

// Searchs the node and its children to see if all the elements
// are local (ie, no Attribute nodes)
function isNodeLocal( node ) {
  if ( node ) {
    if ( isGroup( node ) ) {
      if ( node.items.length == 0 ) {
        return true;
      }
      for ( let n = 0; n < node.items.length; n++ ) {
        const local = isNodeLocal( node.items[n] );
        if ( !local ) {
          return false;
        }
      }
      return true;
    } 
    return false;
    
  }
  return false;
}

// Returns a list of all Attribute nodes beneath the node
function getAllAttributes( node ) {
  if ( isGroup( node ) ) {
    let rtn = []; 
    for ( let n = 0; n < node.items.length; n++ ) {
      const c = node.items[n];
      if ( isAttribute( c ) ) {
        rtn.push( c );
      } else { 
        rtn = rtn.concat( getAllAttributes( c ) )
      }
    }
    return rtn;
  } 

  if ( isAttribute( node ) ) {
    return [ node ];
  } 
  return [];
}
function attributesToTree( attributes ) {
    
  const root = { type : ROOT, path : '', id : 'tree-root', name : 'Attributes', items : [] };
  if ( attributes == null ) {
    return root;
  }
  for ( let n = 0; n < attributes.length; n++ ) {
    const attr = attributes[n];
    const path = Path( attr.path );
    const parent = getParentNode( root, path.pathArray() );
    parent.items.push( { type : ATTRIBUTE, 
                         id : `tree-${attr.id}`, 
                         path : path.path(),
                         name : path.last(), 
                         attribute : attr } );
  }
  return root;
}

function addGroupToTree( root, path ) {
    
  const p = Path( path );
  p.add( 'tmp', true ); // add child node so we create this group.
  getParentNode( root, p.pathArray() );
  return root;
}

function removeGroupFromTree( root, path ) {
    
  const p = Path( path );
  const parent = getParentNode( root, p.pathArray() );
  if ( parent ) {     
    for ( let n = 0; n < parent.items.length; n++ ) {
      const c = parent.items[n];
      if ( isGroup( c ) && c.name == p.last() ) {
        parent.items.splice( n, 1 );
        return c;
      }
    }
  }
  return null;
}

function hasConflict( attrs, path, currentItem ) {
  return Util.hasConflict( attrs, path, currentItem == null, isGroup( currentItem ) )
}

module.exports = {

  findChildByName,
  attributesToTree,
  addGroupToTree,
  removeGroupFromTree,
  getAllAttributes,
  findNodeByPath,
  findNodeById,
  isAttribute,
  isGroup,
  isRoot,
  hasConflict,
  // Returns true if the entire tree beneath node contains
  // only local nodes (ie, virtual groups)
  isNodeLocal

}
